import styled from 'styled-components';

export const Wrapper = styled.div`
	background-color: ${({ theme }) => theme.colors.background.secondary};
	border-radius: 8px;
	@media (max-width: 992px) {
		margin-bottom: 24px;
		width: 100%;
	}
`;
export const Title = styled.div`
	align-items: center;
	font-size: 24px;
	font-weight: 700;
	font-style: normal;
	border-bottom: 1px solid ${({ theme }) => theme.colors.transparent.light15};
	color: ${({ theme }) => theme.colors.text.title};
	display: flex;
	gap: 8px;
	padding: 16px;
	@media (max-width: 992px) {
		font-size: 20px;
		font-weight: 700;
		font-style: normal;
	}
`;
export const Main = styled.div`
	padding: 16px;
`;
export const Text = styled.div`
	font-size: 16px;
	font-weight: 400;

	align-items: center;
	color: ${({ theme }) => theme.colors.text.warning};
	display: flex;
	gap: 10px;
`;
export const Info = styled.div`
	font-size: 16px;
	font-weight: 400;
	font-style: normal;
	color: ${({ theme }) => theme.colors.text.subtitle};
	line-height: 130%;
	margin-top: 20px;

	span {
		font-weight: 500;
	}
`;
export const InfoItem = styled.div`
	margin-bottom: 8px;
`;
